import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ColDef, GridApi, GridReadyEvent } from '@ag-grid-community/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { parse } from 'path';
import { Subscription } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { OptionDialogItens } from 'src/app/system-utils/option-dialog/option-dialog.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { ThemeService } from 'src/app/services/theme.service.js';
import { LanguageServices } from 'src/app/services/LanguageServices.js';

@Component({
    selector: 'sankhya-query',
    templateUrl: './sankhya-query.component.html',
    styleUrls: ['./sankhya-query.component.scss'],
    standalone: false
})
export class SankhyaQueryComponent implements OnInit {

  type = [
    {
        type:4,
        name:'Busca por View'
    },
    {
      type:5,
      name:'Busca por DBExplorer'
  }
  ] as const;

  displayedColumns:ColDef[] = [];
  queryExecuted = false;
  rows:any[] = [];
  private gridApi!: GridApi;
  viewname:string=null;
  campo:string=null;
  condicao:string=null;
  query:string=null;
  @Input()typeSelected:number=0;
  @Input()integrationData:any;
  @Input()cfiForm:FormGroup<any>;
  @Input()step2:FormGroup<any>;
  sub: Subscription;
  @Input()url: any;
  useVariable:boolean = false;
  codeCompany:string = '0';
  codeContract: string = '0';
  

  constructor(private http:HTTPService, private spinner:NgxSpinnerService,
    private dialogServies:DialogService, 
    private userConfiguraion:UserAuthenticationServices,
    public ThemeService:ThemeService,
    public ls:LanguageServices) { }

  onToggleChange(){
      if ( this.useVariable ){
        this.query = "APPLYFORMULA->{@NOMEVARIAVEL}<-APPLYFORMULA"
      }else{
        this.query = "";
      }
  }

  ngOnInit(): void {
      
      if ( ObjectUtil.isNotEmpty(this.cfiForm.get('EXPRESSION').value)){
        if ( this.typeSelected == 5){
            this.disMountJSON(this.cfiForm.get('EXPRESSION').value);
        }else{
            this.disMountXML(this.cfiForm.get('EXPRESSION').value);
        }
        if ( this.hasVariable(this.cfiForm.get('EXPRESSION').value)){
          this.useVariable = true;
        }else{
          this.useVariable = false;
        }
      }
  }

  hasVariable(value){
    if ( value.indexOf('APPLYFORMULA->') > -1 && value.indexOf('<-APPLYFORMULA')>-1){
      return true;
    }
  }

  disMountJSON(value:string){
      try{
        let json = JSON.parse(value);
        let queryJson = ObjectUtil.FindObject(json,'$.requestBody.sql')[0];
        this.query = queryJson;
      }catch(Error){
        if ( this.hasVariable(value)){
            let inicio = value.indexOf('APPLYFORMULA->');
            let fim = value.indexOf('<-APPLYFORMULA')+14;
            this.query = value.substring(inicio,fim);
        }    
        
      }
  }

  disMountXML(value:string){
      try{
        let parser = new DOMParser();
        const doc = parser.parseFromString(value,"application/xml");
        this.viewname =  doc.documentElement.getAttributeNode('viewName').value;
        doc.documentElement.childNodes.forEach(childNode=>{
            
            let field = '';
            if ( childNode.nodeName == 'fields'){
              childNode.childNodes.forEach(child=>{
            
                if ( child.nodeName == 'field'){
                  if ( field == ''){
                    field = child.textContent;
                  }else{
                    field = field+','+child.textContent;
                  }
                }
                
              });
              this.campo = field;
            }else{
              if ( childNode.nodeName == 'where'){
                this.condicao = childNode.textContent;
              }
            }
        })
      }catch(Error){
        
      }

  }


  onGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
  }

  executeQuery(){
    if ( this.integrationData.codeCompany == 0 || !ObjectUtil.isNotEmpty(this.integrationData.codeCompany) ){
      let items:OptionDialogItens[] = [];
      this.userConfiguraion.user.companylist.forEach(data=>{
          let item:OptionDialogItens = {
              key:data.codecompany,
              value:data.codecompany+' - ' +data.companyname
          }
          items.push(item);
      });
      
      this.dialogServies.openOptionDialog('Selecionar o Contexto',items,(data)=>{
        
        this.codeCompany = data;
        this.codeContract = this.userConfiguraion.user.companylist.find(d=>d.codecompany==this.codeCompany).codecontract;
        
        if ( this.typeSelected == 5){
          this.requestJSON();
        }else{
          this.requestXML();
        }
      },()=>{},'400px','120px');
    }else{
      
      this.codeCompany = this.integrationData.codeCompany;
      this.codeContract = this.userConfiguraion.user.companylist.find(d=>d.codecompany==this.codeCompany).codecontract;

      if ( this.typeSelected == 5){
        this.requestJSON();
      }else{
        this.requestXML();
      }
    }
      

  }
  requestXML() {
    
    this.spinner.show('sankhyaquery');

    if (!ObjectUtil.isNotEmpty(this.cfiForm.get('EXPRESSION').value)){
        this.spinner.hide('sankhyaquery');
        throw Error('Preencher a as informaçãoes de consulta de View');
    }

    this.mountXML();

    let ob = {
      "expressao": `getSankhyaDataView(${this.step2.get('URL').value},"${this.cfiForm.get('EXPRESSION').value}")`,
      "novo": true,
      "codecompany": this.codeCompany,
      "codemktp": this.integrationData.codeMktp,
      "codecontract": this.codeContract,
      "values":[]
      //{
        //  "key":"@host",
          //"value":this.url
    }//] 
    
                  
    this.sub = this.http.post(ob,'FormulaServices/test', true,true,false).subscribe(dest=>{
      try{
        let resultado = dest['resultado'];
        this.processResultView(resultado);
        this.spinner.hide('sankhyaquery');
      }catch(Exception){
        this.spinner.hide('sankhyaquery');
      }
    },error=>{
      this.spinner.hide('sankhyaquery');
      throw error;
    });
  }

  ngOnDestroy(){
      if ( this.sub!=null){this.sub.unsubscribe();}
  }
  
  requestJSON() {
    
    this.spinner.show('sankhyaquery');
    if (!ObjectUtil.isNotEmpty(this.query)){
      this.spinner.hide('sankhyaquery');
      throw Error('Preencher a as informaçãoes de consulta de View');
    }

    let queryLocal ='';
    if ( this.hasVariable(this.query) ){
      queryLocal = this.query.replace('APPLYFORMULA->',"");
      queryLocal = queryLocal.replace('<-APPLYFORMULA',"");
      queryLocal = '"'+queryLocal+'"';
    }else{
      queryLocal = this.query;
    }
    
    
    let ob = {
      "expressao": `getSankhyaData(${this.step2.get('URL').value},${queryLocal})`,
      "novo": true,
      "codecompany": this.codeCompany,//this.integrationData.codeCompany,
      "codemktp": this.integrationData.codeMktp,
      "codecontract": this.codeContract,
      "values":[]
      //{
        //  "key":"@host",
          //"value":this.url
    }//] 
    
                  
    this.sub = this.http.post(ob,'FormulaServices/test', true,true,false).subscribe(dest=>{
      try{
        let resultado = dest['resultado'];
        this.processResultDBEXplorer(resultado);
        this.spinner.hide('sankhyaquery');
      }catch(Exception){
        this.spinner.hide('sankhyaquery');
        throw Exception;
      }
      
    },error=>{
      this.spinner.hide('sankhyaquery');
      throw error;
    });
  }

  ngModelChange(evento){
      if ( this.typeSelected == 4){
          this.mountXML();
      }else{
          this.moundDBExplorer();
      }
  }

  moundDBExplorer() {

      let queryLocal = '';
      if ( this.hasVariable(this.query) ){
          queryLocal = this.query;
      }else{
          queryLocal = '"'+this.query+'"';
      }

      let val = `{"serviceName":"DbExplorerSP.executeQuery" ,"requestBody":{"sql":${queryLocal}}}`;
      //{"serviceName":"DbExplorerSP.executeQuery" ,"requestBody":{"sql":APPLYFORMULA->{@qryBasePriceWoo}<-APPLYFORMULA}}
      this.cfiForm.get('EXPRESSION').setValue(val);
  }
  
  mountXML() {
    if ( !this.useVariable ){
      let val =` <query viewName="${this.viewname}">   <fields>    <field>${this.campo}</field>   </fields>  ${ ObjectUtil.isNotEmpty( this.condicao )?`<where>${this.condicao}</where>`:``}</query> `
      this.cfiForm.get('EXPRESSION').setValue(val);
    }else{
      this.cfiForm.get('EXPRESSION').setValue(this.query);
    }
    
  }

  processResultDBEXplorer(resultado){
      this.rows = [];
      let sql:Object[] = JSON.parse(resultado)['SQL'];
      this.mountColumns(sql);
      this.rows = sql;
      this.gridApi.applyTransaction({ add: sql });
  }

  processResultView(resultado){
    this.rows = [];
    try{
      let parser = new DOMParser();
      const doc = parser.parseFromString(resultado,"application/xml");
    
      let result:XPathResult = doc.evaluate('/serviceResponse/responseBody/records/record',doc,null,XPathResult.ORDERED_NODE_SNAPSHOT_TYPE);
    
      let ob:object[] = [];
      for ( var i = 0; i < result.snapshotLength; i++ ){
          let node = result.snapshotItem(i);
          let item:any = {};
          node?.childNodes.forEach(child=>{
              item[child.nodeName] = child.textContent;
          });
          ob.push(item);
      }
      
      this.mountColumns(ob);
      this.rows = ob;
      this.gridApi.applyTransaction({ add: ob });
    }catch(Error){
      
    }


}


  mountColumns(data:any[]){
    this.displayedColumns = [];
    if (data.length > 0 ){
      Object.keys(data[0]).forEach(key=>{
          let col:ColDef = {
              headerName: key,
              field: key,
              sortable:true,
              filter: true,
              resizable: true,
              colId: key
          }
          this.displayedColumns.push(col);
      })
    }
  }

}
